// App.js

import React, { useState } from 'react';
import '../Static/Loginpage.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const LoginPage = () => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    function finalObject(formData) {
        const data = {
            userNm: formData.username,
            pass: formData.password
        }
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const postData = finalObject(formData);
        // console.log(postData)
        try {
            // Make the POST request using axios
            const response = await axios.post(`${baseUrl}?apicall=userLogin`, postData);
            console.log('Response:', response.data);
            const msg = response.data.msg;
            const user = response.data.data;
            // Check if the login is successful
            if (msg === 'Login Successful') {
                // Set a value in session storage
                sessionStorage.setItem('user', JSON.stringify(user)); // or any relevant data

                // Set a timeout to clear the session storage after 1 hour
                // setTimeout(() => {
                //     sessionStorage.removeItem('user');
                //     navigate('/');
                //     window.location.reload();
                // }, 60 * 60 * 1000); // 1 hour in milliseconds


                navigate('/Dashboard');
                // alert(msg);
                // window.location.reload();


            } else {
                alert(msg); // Handle unsuccessful login
            }

        } catch (error) {
            // Handle error if the request fails
            console.error('Error during POST request:', error);
            alert('An error occurred. Please try again.');
        }
    };
    return (
        <>
            <div className="container-b">
                <div className="image-container">
                    {/* <img src={`/image/h.png`} alt="Login Illustration" /> */}
                    <h2 className='title'>Welcome </h2>
                    <h2 className="title">Uniform Manufacture System</h2>

                </div>
                <div className="login-container">
                    {/* <p className="subtitle">Online inventory management system</p> */}
                    <div className="login-box">
                        <h2>Login</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <label>User Name</label>
                                <input
                                    type="text"
                                    name='username'
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="input-group">
                                <label>Password</label>
                                <input
                                    type="password"
                                    name='password'
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <button type="submit" className="login-button">Log in</button>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
};

export default LoginPage;

